export default __webpack_public_path__ + "static/media/reason.e2411b38.svg";